// extracted by mini-css-extract-plugin
export default {"overlay":"sz-z","bodyOpen":"tz-z","content":"uz-z","header":"vz-z","close":"wz-z","closeNoHeading":"xz-z"};